import { motion } from "framer-motion";
import { useLanguage } from "@/context/LanguageContext";
import { IMAGES } from "@/data/images";

const shots = [
  { key: "coral1", rotate: -2 },
  { key: "diverSchool", rotate: 1.5 },
  { key: "coral2", rotate: 2 },
  { key: "goggles", rotate: -1.5 },
  { key: "coral3", rotate: 1 },
  { key: "diver3", rotate: -2.5 },
];

export const Gallery = () => {
  const { t } = useLanguage();
  const g = t.scuba.gallery;
  return (
    <section id="gallery" className="relative bg-ocean-mid py-28 md:py-36 px-6 md:px-12 lg:px-20 overflow-hidden">
      <div className="mb-16">
        <p className="font-mono text-cyan-300 text-xs tracking-[0.25em] mb-4" data-testid="scuba-gallery-eyebrow">
          {g.eyebrow}
        </p>
        <h2 className="font-syne text-4xl md:text-5xl tracking-tight text-white max-w-2xl" data-testid="scuba-gallery-title">
          {g.title}
        </h2>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
        {shots.map((shot, i) => (
          <motion.div
            key={shot.key}
            initial={{ opacity: 0, y: 40, rotate: 0 }}
            whileInView={{ opacity: 1, y: 0, rotate: shot.rotate }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6, delay: i * 0.07 }}
            className={`overflow-hidden rounded-2xl border-2 border-white/10 shadow-2xl ${i % 3 === 1 ? "md:mt-10" : ""}`}
            data-testid={`scuba-gallery-item-${i}`}
          >
            <img
              src={IMAGES.scuba[shot.key]}
              alt="Polvo Scuba"
              className="w-full h-48 md:h-64 object-cover hover:scale-110 transition-transform duration-700"
            />
          </motion.div>
        ))}
      </div>
    </section>
  );
};
